// Slice de UI das Campanhas. Estado de domínio fica no cache do RTK Query; aqui
// só vive o filtro da listagem.
//
// Sentinela: este filtro é multi-loja e usa lista vazia = "todas as lojas", com
// NETWORK_STORE representando as campanhas de rede (storeId null). Difere do CRM
// /contatos/fila, que são de loja única e usam o literal 'all'.
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface CampanhasUiState {
  /** Lojas selecionadas no filtro. Vazio = todas as lojas visíveis. */
  storeFilter: string[];
}

const initialState: CampanhasUiState = {
  storeFilter: [],
};

const campanhasSlice = createSlice({
  name: 'campanhasUi',
  initialState,
  reducers: {
    storeFilterToggled(state, action: PayloadAction<{ storeId: string }>) {
      const idx = state.storeFilter.indexOf(action.payload.storeId);
      if (idx === -1) state.storeFilter.push(action.payload.storeId);
      else state.storeFilter.splice(idx, 1);
    },
    storeFilterCleared(state) {
      state.storeFilter = [];
    },
  },
});

export const { storeFilterToggled, storeFilterCleared } = campanhasSlice.actions;

export const campanhasUiReducer = campanhasSlice.reducer;

type Root = { campanhasUi: CampanhasUiState };

export const selectCampanhasStoreFilter = (s: Root): string[] => s.campanhasUi.storeFilter;
